module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('upload-media', {
    attrs: {
      "accept": this.accept,
      "listMedia": _vm.media,
      "influencer": _vm.influencer,
      "campaign": _vm.campaign
    },
    on: {
      "change": _vm.mediaChanged
    }
  }), _vm._v(" "), (_vm.supportsVideoUpload) ? _c('div', {
    staticClass: "video-compression-suggestion mt-3"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": "",
      "color": "info"
    }
  }, [_vm._v("mdi-information-outline")]), _vm._v(" "), _c('span', [_vm._v("Video file too large?")]), _vm._v(" "), _c('a', {
    staticClass: "ml-1",
    attrs: {
      "href": "https://www.veed.io/new?tool=compress",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Compress your video with VEED")]), _vm._v(" "), _c('span', [_vm._v("  before uploading.")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.isVideoLink) ? _c('v-row', {
    staticStyle: {
      "margin-bottom": "0px !important"
    }
  }, [_c('v-col', {
    staticStyle: {
      "margin-bottom": "0px !important"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "filled": "",
      "clearable": "",
      "type": "text",
      "label": "Video or Drive Link (use this field if automatic upload do not work or your video file exceeds 100mb)",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.vdoLink),
      callback: function($$v) {
        _vm.vdoLink = $$v
      },
      expression: "vdoLink"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isRemark) ? _c('v-row', {
    staticStyle: {
      "margin-bottom": "0px !important"
    }
  }, [_c('v-col', {
    staticStyle: {
      "margin-bottom": "0px !important"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "name": "remark",
      "label": "Remark",
      "clearable": "",
      "auto-grow": "",
      "filled": "",
      "rows": "4",
      "rules": [_vm.rules.length(2200)],
      "counter": ""
    },
    model: {
      value: (_vm.remark),
      callback: function($$v) {
        _vm.remark = $$v
      },
      expression: "remark"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "name": "caption",
      "label": _vm.captionLabel,
      "clearable": "",
      "auto-grow": "",
      "filled": "",
      "rows": "4",
      "rules": [_vm.rules.length(2200)],
      "counter": ""
    },
    model: {
      value: (_vm.caption),
      callback: function($$v) {
        _vm.caption = $$v
      },
      expression: "caption"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63f74616"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/post/PostForm.vue
// module id = 2159
// module chunks = 0